// extracted by mini-css-extract-plugin
module.exports = {"videoPlayerComponent":"VideoDetailsPlayer-modulevideoPlayerComponentY9i"};